var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"toTop",attrs:{"href":"#","aria-label":_vm.$t('to_top')},on:{"click":function($event){$event.preventDefault();return _vm.toTop.apply(null, arguments)}}},[_c('i',{staticClass:"svg-icon arrow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }